import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
type Work = {
  title: string;
  tags: string[];
  big?: boolean;
  mockup?: 'pc';
  image?: string;
  logo?: string;
  logoBg?: string;
  bgClass?: string;
  mark?: string;
  link: string;
};
const works: Work[] = [{
  title: 'Tende Pay',
  tags: ['Branding', 'Web', 'UI/UX'],
  big: true,
  mockup: 'pc',
  image: 'https://cdn.magicpatterns.com/uploads/3j7BPN9jAyodYERgHj7ddA/Screenshot_2026-07-03_at_11.51.16.png',
  link: '/work/tende-pay'
}, {
  title: 'NovaCloud Solutions',
  tags: ['Branding', 'Web Design', 'Development'],
  image: 'https://cdn.magicpatterns.com/uploads/wExVB9Wo1JJn6vjYjZzBtQ/nova.png',
  link: '/work/novacloud'
}, {
  title: 'FlowKey Labs',
  tags: ['Identity', 'Web', 'UI/UX'],
  logo: 'https://cdn.magicpatterns.com/uploads/g3xSNcTwxUKYvMqytRpxH8/Frame_2121457531.png',
  logoBg: '#0f1e17',
  link: '/work/flowkey'
}];
export function SelectedWork() {
  return <section id="work" className="sec" data-id="element-185">
      <div className="sec__head" data-id="element-186">
        <div data-id="element-187">
          <div className="eyebrow mb-5" data-id="element-188">Selected work</div>
          <h2 data-id="element-189">
            Brands we've helped <span className="serif" data-id="element-190">build</span>.
          </h2>
        </div>
        <Link to="/#contact" className="ghost" data-id="element-191">
          All case studies
          <ArrowRight size={16} data-id="element-192" />
        </Link>
      </div>

      <div className="work" data-id="element-193">
        {works.map(work => <Link to={work.link} key={work.title} className={`case ${work.big ? 'big' : ''}`} data-id="element-194">
            {work.mockup === 'pc' && work.image ? <div className="thumb" style={{
          aspectRatio: '16 / 9',
          filter: 'none'
        }} data-id="element-195">
                {/* styled desktop mockup — always centered & fully contained */}
                <div className="absolute inset-0 flex items-center justify-center p-[5%] bg-gradient-to-br from-[#101826] to-[#0a0c11]" data-id="element-196">
                  <div className="w-full max-w-[74%] h-full flex flex-col items-center justify-center" data-id="element-197">
                    {/* monitor */}
                    <div className="w-full min-h-0 flex flex-col rounded-t-xl rounded-b-md border border-line-2 bg-[#1a1c22] p-1.5 shadow-2xl" data-id="element-198">
                      <div className="flex flex-col min-h-0 rounded-md overflow-hidden bg-canvas border border-line" data-id="element-199">
                        <div className="flex items-center gap-1.5 px-3 py-2 border-b border-line flex-none" data-id="element-200">
                          <span className="w-2 h-2 rounded-full bg-[#ff5f57]" data-id="element-201" />
                          <span className="w-2 h-2 rounded-full bg-[#febc2e]" data-id="element-202" />
                          <span className="w-2 h-2 rounded-full bg-[#28c840]" data-id="element-203" />
                        </div>
                        <img src={work.image} alt={`${work.title} marketing site`} className="w-full flex-1 min-h-0 object-cover object-top block" loading="lazy" data-id="element-204" />
                      </div>
                    </div>
                    {/* stand */}
                    <div className="w-10 h-3.5 bg-[#1a1c22] border-x border-b border-line-2 flex-none" data-id="element-205" />
                    <div className="w-28 h-1.5 rounded-full bg-[#1a1c22] border border-line-2 flex-none" data-id="element-206" />
                  </div>
                </div>
              </div> : <div className="thumb" data-id="element-207">
                {work.image ? <img src={work.image} alt={`${work.title} branding`} className="absolute inset-0 w-full h-full object-cover" data-id="element-208" /> : work.logo ? <div className="absolute inset-0 flex items-center justify-center p-12" style={{
            background: work.logoBg ?? '#0f1e17'
          }} data-id="element-209">
                    <img src={work.logo} alt={`${work.title} logo`} className="max-w-[62%] h-auto" loading="lazy" data-id="element-210" />
                  </div> : <div className={`mkbg ${work.bgClass ?? ''}`} data-id="element-211">
                    {work.mark}
                  </div>}
              </div>}
            <div className="body" data-id="element-212">
              <div className="top" data-id="element-213">
                <h3 data-id="element-214">{work.title}</h3>
              </div>
              <div className="tags" data-id="element-215">
                {work.tags.map(tag => <span key={tag} className="tag" data-id="element-216">
                    {tag}
                  </span>)}
              </div>
            </div>
          </Link>)}
      </div>
    </section>;
}